import { jobs } from './jobs';

export const common = {
  nav: {
    home: 'Home',
    jobs: 'Job Offers',
    candidates: 'Candidates',
    employers: 'Employers',
    international: 'International Recruitment',
    login: 'Login',
    register: 'Register',
  },
  hero: {
    title1: 'Find your',
    title2: 'next professional',
    title3: 'challenge',
    subtitle: 'Connect with the best career opportunities and the most qualified talents',
    searchPlaceholder: 'Job title, keyword, company...',
    locationPlaceholder: 'City, region...',
    contractType: 'Contract type',
    searchButton: 'Search',
    uploadCV: 'Upload my CV',
    hireTalent: 'Hire Talent'
  },
  metrics: {
    jobs: 'Active job offers',
    placements: 'Candidates placed',
    companies: 'Partner companies'
  },
  jobs: {
    title: 'Latest Opportunities',
    viewOffer: 'View offer',
    cdi: 'Permanent',
    cdd: 'Fixed-term',
    stage: 'Internship',
    freelance: 'Freelance',
    all: 'All'
  },
  testimonials: {
    label: 'Candidate Testimonial',
    title1: 'An exceptional',
    title2: 'recruitment experience',
    quote: '« Thanks to Travail Global, I found the ideal position in less than two weeks. The team listened to my needs and supported me throughout the process. A remarkable professional and human experience. »',
    author: 'Sophie Martin, Marketing Manager'
  },
  features: {
    title: 'Why Choose Travail Global',
    description: 'A complete platform connecting talents with opportunities, worldwide',
    forCandidates: 'For Candidates',
    candidatesDesc: 'Access thousands of offers, create your professional profile and receive personalized recommendations',
    forCompanies: 'For Companies',
    companiesDesc: 'Find the best talents, manage your recruitments and develop your teams efficiently',
    international: 'International Recruitment',
    internationalDesc: 'Expand your horizons with our global network of talents and opportunities'
  },
  cta: {
    ready: 'Ready to start?',
    join1: 'Join',
    join2: 'our community',
    join3: 'today',
    createAccount: 'Create your free account',
    ctaDescription: 'Whether you are looking for your next professional challenge or the ideal talent for your company, Travail Global supports you at every step of your journey.',
    startNow: 'Start now'
  },
  footer: {
    description: 'Your trusted partner for recruitment and career development',
    newsletter: 'Stay Informed',
    emailPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    legal: 'By subscribing, you accept our',
    privacyPolicy: 'privacy policy',
    quickLinks: 'Quick Links',
    forCandidates: 'For Candidates',
    forEmployers: 'For Employers',
    resources: 'Resources',
    blog: 'Blog',
    careerAdvice: 'Career Advice',
    salaryGuide: 'Salary Guide',
    copyright: 'All rights reserved',
    terms: 'Terms of Use',
    privacy: 'Privacy',
    cookies: 'Cookies'
  }
};

export { jobs };